import { render } from "./EditTalentModal.vue?vue&type=template&id=063e6064&scoped=true"
import script from "./EditTalentModal.vue?vue&type=script&lang=js"
export * from "./EditTalentModal.vue?vue&type=script&lang=js"

import "./EditTalentModal.vue?vue&type=style&index=0&id=063e6064&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063e6064"]])

export default __exports__